/**
 * Accordion rows with their own picture (Why Aspilon on Home): when a row opens, the picture of the section's
 * media block changes to that row's picture. Rows without a picture leave the current one in place.
 */
const SELECTOR = 'details[data-media-src]';

function swapFor(details) {
  const section = details.closest('.shopify-section');
  const image = section?.querySelector('img.media-block__media, .media-block__media img');
  if (!image || !details.dataset.mediaSrc || image.dataset.currentRow === details.dataset.mediaSrc) return;

  image.dataset.currentRow = details.dataset.mediaSrc;
  image.style.transition = 'opacity 200ms ease';
  image.style.opacity = '0';
  const done = () => {
    image.removeAttribute('srcset');
    image.src = details.dataset.mediaSrc;
    if (details.dataset.mediaSrcset) image.srcset = details.dataset.mediaSrcset;
    image.alt = details.dataset.mediaAlt || '';
    image.addEventListener('load', () => (image.style.opacity = '1'), { once: true });
    if (image.complete) image.style.opacity = '1';
  };
  window.matchMedia('(prefers-reduced-motion: reduce)').matches ? done() : setTimeout(done, 200);
}

document.addEventListener(
  'toggle',
  (event) => {
    const details = event.target;
    if (details instanceof HTMLDetailsElement && details.matches(SELECTOR) && details.open) swapFor(details);
  },
  true
);

for (const details of document.querySelectorAll(`${SELECTOR}[open]`)) swapFor(details);
